import { Box, Typography, styled } from '@mui/material';
import React from 'react'
import { downloadMedia, formatDate } from '../../../Utils/UsabaleUtil';
import { useChatContex } from '../../../contex/ChatContex';
import { iconPDF } from '../../Statics/Data';
import { GetApp as GetAppIcon } from '@mui/icons-material';




const Wrapper = styled(Box)`
   background: #FFFFFF;
    padding: 5px;
    max-width: 60%;
    width: fit-content;
    display: flex;
    border-radius: 10px;
    word-break: break-word;
`;
    
const Own = styled(Box)`
    background: #dcf8c6;
    padding: 5px;
    max-width: 60%;
    width: fit-content;
    margin-left: auto;
    display: flex;
    border-radius: 10px;
    word-break: break-word;
`;

const Text = styled(Typography)`
    font-size: 14px;
    padding: 0 25px 0 5px;
`;

const Time = styled(Typography)`
    font-size: 10px;
    color: #919191;
    margin-top: 6px;
    word-break: keep-all;
    margin-top: auto;
`;



function Messagesess({mesage}) {

    const {login}=useChatContex()
    return (

        <>
            {
                login.sub===mesage.senderId?
                <Own>
                   {
                        mesage.type === 'file' ? <ImageMessage mesage={mesage} /> : <TextMessage mesage={mesage} />
                   }
                   
               </Own>
               :
               <Wrapper>
                      {
                        mesage.type === 'file' ? <ImageMessage mesage={mesage} /> : <TextMessage mesage={mesage} />
                      }
               </Wrapper>

            }
        </>
        
    )
}


const TextMessage = ({ mesage }) => {
    
    return (
        <>
            <Text>{mesage.text}</Text>
            <Time>{formatDate(mesage.createdAt)}</Time>
        </>
    )
}


const ImageMessage = ({ mesage }) => {


    return (
        <div style={{ position: 'relative' }}>
            {
                mesage?.text?.includes('.pdf') ?
                    <div style={{ display: 'flex' }}>
                        <img src={iconPDF} alt="pdf-icon" style={{ width: 80 }} />
                        <Typography style={{ fontSize: 14 }} >{mesage.text.split("/").pop()}</Typography>
                    </div>
                : 
                
                    <img style={{ width: 300, height: '100%', objectFit: 'cover' }} src={mesage.text} alt={mesage.text} />
            }
            <Time style={{ position: 'absolute', bottom: 0, right: 0 }}>
                <GetAppIcon 
                    onClick={(e) => downloadMedia(e, mesage.text)} 
                    fontSize='small' 
                    style={{ marginRight: 10, border: '1px solid grey', borderRadius: '50%',cursor:"pointer" }} 
                />
                {formatDate(mesage.createdAt)}
            </Time>
        </div>
    )
}





export default Messagesess
